import {QueryBuilder} from 'src/app/angularJS/services/query-builder.service';

export class SearchController {
  public static $inject = ['QueryBuilder'];
  public searchTerm: string;
  public onPerformSearch: Function;
  public isInAdvancedMode: boolean;
  public searchRefs: { [key: string]: any };

  constructor(private queryBuilder: QueryBuilder) {
    this.activate();
  }

  /**
   * Performs a search, calling a callback function with a constructed query string
   */
  public performSearch = () => {
    const query = this.queryBuilder.newParam();
    let first = true;

    if (this.isInAdvancedMode) {
      for (const key in this.searchRefs) {
        if (this.searchRefs[key].value) {
          if (key !== 'toDate') {
            if (!first) {
              query.and();
            } else {
              first = false;
            }

            if (this.searchRefs[key].isDate) {
              query
                .isGreaterOrEqualTo(
                  this.searchRefs.createdFromDate.key,
                  moment(this.searchRefs.createdFromDate.value).format('YYYY-MM-DDT00:00:00') + 'Z'
                )
                .and()
                .isLessThanOrEqualTo(
                  this.searchRefs.toDate.key,
                  moment(this.searchRefs.toDate.value).format('YYYY-MM-DDT23:59:59') + 'Z'
                );
            } else {
              query[this.searchRefs[key].queryType](this.searchRefs[key].key, this.searchRefs[key].value);
            }
          }
        }
      }
    } else {
      query
        .fieldContains('state.name', this.searchTerm)
        .or()
        .fieldContains('externalId', this.searchTerm)
        .or()
        .fieldContains('target.reference', this.searchTerm);
    }

    query.sortBy([
      {columnName: 'timestamp', direction: 'desc'}
    ]);

    this.onPerformSearch(query.getParam());
  }

  /**
   * Clears the search term
   */
  public clearSearchTerm = () => {
    this.searchTerm = '';
  }

  /**
   * Toggles the advanced search menu
   */
  public openAdvancedControls = () => {
    this.clearSearchTerm();
    this.isInAdvancedMode = !this.isInAdvancedMode;
  }

  /**
   * Instantiates the controller and sets controller defaults
   */
  private activate = () => {
    this.searchRefs = {
      fulfilmentReference: {
        key: 'externalId',
        value: undefined,
        queryType: 'fieldIs',
        isDate: false
      },
      isrn: {
        key: 'target.reference',
        value: undefined,
        queryType: 'fieldIs',
        isDate: false
      },
      status: {
        key: 'state.name',
        value: undefined,
        queryType: 'fieldContains',
        isDate: false
      },
      createdFromDate: {
        key: 'timestamp',
        value: undefined,
        queryType: 'fieldContains',
        isDate: true
      },
      toDate: {
        key: 'timestamp',
        value: undefined,
        queryType: 'fieldContains',
        isDate: true
      }
    };
  }
}
